/**
 * OrbDocCoreConceptsTraitsSLOrbDocCoreConceptsTraitsSLPage
 *
 * Page component for OrbDocCoreConceptsTraitsSLOrbDocCoreConceptsTraitsSLPage
 * Path: /sl/docs/core-concepts/traits
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocCoreConceptsTraitsSLDocScreenView as __OrbDocCoreConceptsTraitsSLDocScreenView } from '@/components/traits/OrbDocCoreConceptsTraitsSLDocScreenView';
import { OrbDocCoreConceptsTraitsSLDocAnalyticsView as __OrbDocCoreConceptsTraitsSLDocAnalyticsView } from '@/components/traits/OrbDocCoreConceptsTraitsSLDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';

interface OrbDocCoreConceptsTraitsSLOrbDocCoreConceptsTraitsSLPageProps {
  // Add any page-level props here
}

export function OrbDocCoreConceptsTraitsSLOrbDocCoreConceptsTraitsSLPage(_props: OrbDocCoreConceptsTraitsSLOrbDocCoreConceptsTraitsSLPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Lastnosti","description":"Avtomati stanj, ki se odzivajo na dogodke, preverjajo pogoje, izvajajo učinke in rišejo zaslon.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/core-concepts/traits"},{"locale":"ar","path":"/ar/docs/core-concepts/traits"},{"locale":"sl","path":"/sl/docs/core-concepts/traits"}],"defaultLocale":"en", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocCoreConceptsTraitsSLDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocCoreConceptsTraitsSLDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default OrbDocCoreConceptsTraitsSLOrbDocCoreConceptsTraitsSLPage;
